import { api } from 'shared/api'

import { applicationInstallationSchemas } from './schemas'

export const ApplicationInstallationApi = {
  installApplication: api.account.createPost({
    url: '/appStore/install',
    schemas: applicationInstallationSchemas.installApplication,
  }),
  fetchAccounts: api.account.createGet({
    url: '/application/accounts',
    schemas: applicationInstallationSchemas.fetchAccounts,
  }),
  fetchApplicationByHash: api.account.createGet({
    url: '/appStore/get',
    schemas: applicationInstallationSchemas.fetchApplicationByHash,
  }),
}
